export default ({
    name : 'FloatingBanner'
    , data () {
        return {
        }
    }
    , created () {
        this.code = 'floating_banner';
        this.basic = this.getDetailDataByCode(this.code);
        return {}
    }
    , mounted () {
    }
    , computed : {
        //useFloatingBanner () {
            //if (this.basic === false) return false;
            //if (this.basic.use != 'Y') return false;
            ////if (this.isEmptyAnyone() === true) return false;
            //return true;
        //}
        useShopPhone () {
            if (this.isDisplayTypeValueAll() === false && this.getDisplayType() != this.getDisplayTypeEnums(0)) return false;
            //if (this.isEmptyPhoneValue() === true) return false;
            return true;
        }
        , useKakaoPlusFriend () {
            if (this.isDisplayTypeValueAll() === false && this.getDisplayType() != this.getDisplayTypeEnums(1)) return false;
            //if (this.isEmptyKakaoValue() === true) return false;
            return true;
        }
        , useAll () {
            //if (this.isDisplayTypeValueAll() === false || this.isEmptyAnyone() === true) return false;
            if (this.isDisplayTypeValueAll() === false) return false;
            return true;
        }
        , telNumber () {
            let val = this.getPhoneValue().replace(/-/g, '')
            return `tel:${val}`
        }
        , linkKakao () {
            let regexp = /^http(s)?\:\/\//is
            let kkp = this.getKakaoValue()
            if (regexp.test(kkp) === true) {
                return kkp
            }
            return `http://${kkp}`;
        }
    }
    , methods : {
        getDisplayType () {
            return this.basic.data.display_type.value;
        }
        , getDisplayTypeEnums (key) {
            return this.basic.data.display_type.enums[key];
        }
        , getPhoneValue () {
            return this.basic.data.shop_phone.value;
        }
        , getKakaoValue () {
            return this.basic.data.shop_kakao_plus_friend.value;
        }
        , isEmptyPhoneValue () {
            if (this.getPhoneValue().length == 0) return true;
            if (/^[0-9\-]*$/.test(this.getPhoneValue()) === false) return true;
            return false;
        }
        , isEmptyKakaoValue () {
            if (this.getKakaoValue().length == 0) return true;
            return false;
        }
        , isEmptyAnyone () {
            if (this.isEmptyPhoneValue() === true || this.isEmptyKakaoValue() === true) return true;
            return false;
        }
        , isDisplayTypeValueAll () {
            if (this.getDisplayType() != this.getDisplayTypeEnums(2)) return false;
            return true;
        }
        , goToTop () {
            $m('html, body, .fix-body .wrap').stop().animate({scrollTop: 0}, 500);
            return
        }
    }
    , updated () {
    }
})
